import { PostResultsState } from '../../types/PostResults';
import { GlobalActionTypes, RESET_GLOBAL_STATE } from '../types';
import {
  PostResultsActionTypes,
  RESET_ALLOCATED_MODERATOR_STATE,
  RESET_CENTRE_STATE,
  RESET_CONSORTIUM_STATE,
  RESET_MODERATORS_STATE,
  SET_ALLOCATED_MODERATOR,
  SET_CENTRE,
  SET_CONSORTIUM,
  SET_FETCHING_CENTRE,
  SET_MODERATORS,
} from './types';

export const initialValue: PostResultsState = {
  centre: undefined,
  consortium: undefined,
  moderators: [],
  allocatedModerator: undefined,
  isFetchingCentre: false,
};

export default (state = initialValue, action: PostResultsActionTypes | GlobalActionTypes): PostResultsState => {
  switch (action.type) {
    case RESET_GLOBAL_STATE: {
      return initialValue;
    }
    case SET_CENTRE: {
      return { ...state, centre: action.payload };
    }
    case RESET_CENTRE_STATE: {
      return { ...state, centre: initialValue.centre };
    }
    case SET_CONSORTIUM: {
      return { ...state, consortium: action.payload };
    }
    case RESET_CONSORTIUM_STATE: {
      return { ...state, consortium: initialValue.consortium };
    }
    case SET_MODERATORS: {
      return { ...state, moderators: action.payload };
    }
    case RESET_MODERATORS_STATE: {
      return { ...state, moderators: initialValue.moderators };
    }
    case SET_ALLOCATED_MODERATOR: {
      return { ...state, allocatedModerator: action.payload };
    }
    case RESET_ALLOCATED_MODERATOR_STATE: {
      return { ...state, allocatedModerator: initialValue.allocatedModerator };
    }
    case SET_FETCHING_CENTRE: {
      return { ...state, isFetchingCentre: action.payload };
    }
    default:
      return state;
  }
};
